import type * as React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import Alert from '@cloudscape-design/components/alert';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';

/**
 * Tela `/billing/tax/:tenantId` — placeholder dos dados fiscais do tenant (só
 * um aviso; não lê nem grava nada).
 *
 * Origem: sem issue — commit ae81f4d21, 2026-05-05 (Sprint 16, rotas
 * `/billing/*`).
 *
 * Usado por: rota `billing/tax/:tenantId` (`routes/router.tsx`); sem item no
 * menu. Spec: `docs/screens/billing-tax-data.md`.
 */
export function TaxDataPage(): React.JSX.Element {
  const { t } = useTranslation();
  const { tenantId } = useParams<{ tenantId: string }>();

  return (
    <ContentLayout
      header={<Header variant="h1" description={tenantId ?? '—'}>{t('billing.tax.title')}</Header>}
    >
      <Alert type="info">{t('billing.tax.placeholder')}</Alert>
    </ContentLayout>
  );
}
